<template>
  <div class="content">
    <div class="container-fluid">
      <!-- Detail View Modal -->
      <div class="row">
        <b-modal
            id="modal-top-Details"
            hide-footer
            title="Details"
            content-class="shadow" 
            size="xl"
          >
            <template #modal-header="{ close }">
              <h5>Detail</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="
                    close();
                    clearData();
                  "
                ></b-icon>
              </p>
            </template>
            <b-row>
              <b-col md="6" v-if="selectedTenant1.ContractInformation && selectedTenant1.ContractInformation.length > 0">
                <b-table-simple
                    :small="true"
                    sticky-header
                    style="max-height: 395px;"
                    striped
                    responsive="sm"
                    hover
                    bordered
                  >
                    <b-thead>
                      <b-tr>
                          <b-th colspan="6" style="font-weight: 700;text-align: center !important;">Contracts</b-th>
                      </b-tr>
                      <b-tr>
                        <b-th></b-th>
                        <b-th>Tenant</b-th>
                        <b-th>Tenant Phone No</b-th>
                        <b-th>From</b-th>
                        <b-th>To</b-th>
                        <b-th>Total Payment Received</b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr
                        v-for="(contract, index) in selectedTenant1.ContractInformation"
                        :key="index"
                      >
                        <b-td>
                          <b-badge v-if="contract.Status == 1" variant="primary">Current</b-badge>
                        </b-td>
                        <b-td>{{contract.TenantFullName}}</b-td>
                        <b-td>{{contract.TenantPhoneNumber}}</b-td>
                        <b-td>{{contract.ContractStartDate}}</b-td>
                        <b-td>{{contract.ContractEndDate}}</b-td>
                        <b-td>{{numberWithCommas(contract.TotalAmountForThisContract)}}</b-td>
                      </b-tr>
                      <b-tr>
                        <b-td colspan="5" style="font-weight: 700;text-align: right !important;">Total</b-td>
                        <b-td style="font-weight: 700;">{{numberWithCommas(selectedTenant1.TotalAmountForHouse)}}</b-td>
                      </b-tr>
                    </b-tbody>
                </b-table-simple>
              </b-col>
              <b-col md="6">
               <b-table-simple
                  :small="true"
                  sticky-header
                  style="max-height: 395px;"
                  striped
                  responsive="sm"
                  hover
                  bordered
                >
                  <b-thead>
                     <b-tr>
                        <b-th colspan="5" style="font-weight: 700;text-align: center !important;">Family Information</b-th>
                     </b-tr>
                    <b-tr>
                      <b-th style="width: 15%">Full Name</b-th>
                      <b-th style="width: 12%">Family Type</b-th>
                      <b-th style="width: 12%">Address</b-th>
                      <b-th style="width: 15%">Phone Number</b-th>
                      <b-th style="width: 15%">Sex</b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr
                      v-for="(family, index) in selectedTenant1.familyInformation"
                      :key="index"
                    >
                      <b-td>{{family.fullName}}</b-td>
                      <b-td>{{family.familyType}}</b-td>
                      <b-td>{{family.address}}</b-td>
                      <b-td>{{family.phoneNumber}}</b-td>
                      <b-td>{{family.sex}}</b-td>
                    </b-tr>
                  </b-tbody>
               </b-table-simple>
              </b-col>
            </b-row>
             <b-row>
              <b-col md="8" v-if="selectedTenant1.paymentInformation && selectedTenant1.paymentInformation.length > 0">
                <b-table-simple
                    :small="true"
                    sticky-header
                    style="max-height: 395px;"
                    striped
                    responsive="sm"
                    hover
                    bordered
                  >
                    <b-thead>
                      <b-tr>
                          <b-th colspan="5" style="font-weight: 700;text-align: center !important;">Payment Information</b-th>
                      </b-tr>
                      <b-tr>
                        <b-th style="width: 20%">Rent Payed Amount</b-th>
                        <b-th style="width: 20%">Payment For</b-th>
                        <b-th style="width: 20%">Payment Date</b-th>
                        <b-th style="width: 20%">Transaction Ref</b-th>
                        <b-th style="width: 20%">Payment Method</b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr
                        v-for="(payment, index) in selectedTenant1.paymentInformation"
                        :key="index"
                      >
                        <b-td>{{numberWithCommas(payment.payedAmount)}}</b-td>
                        <b-td>{{payment.paymentCategory}}</b-td>
                        <b-td>{{payment.paymentDate}}</b-td>
                        <b-td>{{payment.transactionRef}}</b-td>
                        <b-td>{{payment.paymentMethod}}</b-td>
                      </b-tr>
                    </b-tbody>
                </b-table-simple>
              </b-col>
            </b-row>
        </b-modal>
      </div>
      
      <!-- Main List View -->
      <div class="row mt-3">
        <div class="col-12">
          <card class="strpied-tabled-with-hover"
                body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <b-row class="mb-2">
                <b-col lg="2">
                  <label class="small mb-1">Owner</label>
                  <b-form-select v-model="filters.userId" :options="ownerUserOptions" size="sm"></b-form-select>
                </b-col>
                <b-col lg="2">
                  <label class="small mb-1">Registered By</label>
                  <b-form-select v-model="filters.registeredBy" :options="allUserOptions" size="sm"></b-form-select>
                </b-col>
                <b-col lg="2">
                  <label class="small mb-1">Created Date</label>
                  <b-form-input v-model="filters.createdDate" type="date" size="sm"></b-form-input>
                </b-col>
                <b-col lg="2">
                  <label class="small mb-1">Status</label>
                  <b-form-select v-model="filters.status" :options="statusOptions" size="sm"></b-form-select>
                </b-col>
                <!-- <b-col lg="2">
                  <label class="small mb-1">Tenant Status</label>
                  <b-form-select v-model="filters.tenantStatus" :options="tenantStatusOptions" size="sm"></b-form-select>
                </b-col> -->
                <b-col lg="1" class="d-flex align-items-end">
                  <b-button size="sm" variant="outline-secondary" @click="resetFilters">Reset</b-button>
                </b-col>
                <b-col lg="2" class="d-flex align-items-end">
                  <b-button size="sm" variant="success" class="mr-1" @click="exportExcel"><b-icon icon="file-earmark-excel"></b-icon> Excel</b-button>
                  <b-button size="sm" variant="danger" @click="exportPDF"><b-icon icon="file-earmark-pdf"></b-icon> PDF</b-button>
                </b-col>
                <b-col lg="3" class="my-1">
                  <b-form-group class="mb-0">
                    <b-input-group size="sm">
                      <b-form-input v-model="filter" type="search" placeholder="Search"></b-form-input>
                      <b-input-group-append>
                        <b-button class="btn-secondary" :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </template>
            
            <div class="table-container">
            <b-table-simple
              :small="true"
              sticky-header
              style="max-height: 395px;"
              striped
              responsive
              hover
            >
              <b-thead>
                <b-tr>
                  <b-th>No.</b-th>
                  <b-th>Tenant Name</b-th>
                  <b-th>Phonenumber</b-th>
                  <b-th>Email</b-th>
                  <b-th>Address</b-th>
                  <b-th>Status</b-th>
                  <b-th>Created At</b-th>
                  <b-th>Created Date</b-th>
                  <b-th sticky-column style="height: 45px;">Actions</b-th>
                </b-tr>
              </b-thead>
              <template v-if="spinner">
                <b-tbody class="text-center">
                  <b-tr >
                    <b-td colspan="9" class="text-center" style="display: table-cell">
                      <b-spinner
                        style="height: 3rem; width: 3rem;"
                        variant="warning"
                      ></b-spinner>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </template>
              <template v-else>
                <b-tbody>
                  <template v-if="filterTable.length === 0">
                    <b-tr>
                      <b-td colspan="9" class="text-center">Nothing found</b-td>
                    </b-tr>
                  </template>
                  <template v-else>
                    <b-tr
                      v-for="(item, index) in filterTable"
                      :key="item.tenantId || index"
                      @click="ViewDetail(item.tenantId)"
                      style="cursor: pointer;"
                    >
                      <b-td>{{(currentPage - 1) * perPage + index + 1}}</b-td>
                      <b-td>{{item.fullName}}</b-td>
                      <b-td>{{item.phoneNumber}}</b-td>
                      <b-td>{{item.email || 'N/A'}}</b-td>
                      <b-td>{{item.address}}</b-td>
                      <b-td>
                        <b-badge :variant="getStatusVariant(item.tenantStatus)">
                          {{item.tenantStatus}}
                        </b-badge>
                      </b-td>
                      <b-td>{{formatDate(item.createdDate)}}</b-td>
                      <b-td>{{item.registeredBy}}</b-td>
                      <b-td sticky-column>
                        <b-icon icon="eye-fill" class="btn-icon mr-2" @click.stop="ViewDetail(item.tenantId)" v-b-tooltip.hover title="View Tenant Details"></b-icon>
                      </b-td>
                    </b-tr>
                  </template>
                </b-tbody>
              </template>
            </b-table-simple>
            </div>
            <div class="pagination-container mt-2">
            <b-row>
                <b-col md="3">
                  <b-form-group
                    id="fieldset-horizontal"
                    label-cols="8" label-cols-xs="8" label-size="md"
                    label="records per page"
                    label-for="input-horizontal"
                    label-align-xl="right"  
                  >
                    <b-form-select id="input-horizontal" v-model="perPage" :options="pageOptions" @change="changePerPage"></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="9">
                  <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="displayRows" @page-click="changePage" align="right"></b-pagination>
                </b-col>
              </b-row>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LTable from 'src/components/Table.vue'
  import Card from 'src/components/Cards/Card.vue'
  import * as XLSX from 'xlsx'
  import jsPDF from 'jspdf'
  import 'jspdf-autotable'

  export default {
    components: {
      LTable,
      Card
    },
    data () {
      return {
        modulePermission: {
          view: 1,
          create: 0,
          update: 0,
          delete: 0
        },
        totalRows: 0,
        currentPage: 1,
        perPage: 7,
        pageOptions: [
          {value: 7, text: 7},
          {value: 10, text: 10},
          {value: 25, text: 25},
          {value: 50, text: 50},
          {value: 100, text: 100}
        ],
        items: [],
        allItems: [],
        filter: "",
        spinner: true,
        selectedTenant1: {
          tenantId: null,
          ContractInformation: [],
          paymentInformation: [],
          familyInformation: [],
          TotalAmountForHouse: 0,
        },
        filters: {
          userId: null,
          registeredBy: null,
          createdDate: "",
          status: null,
          tenantStatus: null
        },
        ownerUserOptions: [{value: null, text: "All Owners"}],
        allUserOptions: [{value: null, text: "All Users"}],
        statusOptions: [
          {value: null, text: "All Status"},
          {value: 1, text: "Rented"},
          {value: 0, text: "Free tenant"}
        ],
        tenantStatusOptions: [
          {value: null, text: "All"},
          {value: "Free Tenant", text: "Free Tenant"},
          {value: "Rented", text: "Rented"}
        ]
      }
    },
    watch: {
      'filters.userId'() { this.applyFilters(); },
      'filters.registeredBy'() { this.applyFilters(); },
      'filters.createdDate'() { this.applyFilters(); },
      'filters.status'() { this.applyFilters(); },
      'filters.tenantStatus'() { this.applyFilters(); },
      filter(val) {
        if (val && val.trim()) this.fetchAllForSearch();
        else this.allItems = [];
      }
    },
    computed: {
      searchSource() {
        return this.filter && this.allItems.length ? this.allItems : this.items;
      },
      filterTable() {
        if (!this.filter) return this.items;
        const s = this.filter.trim().toLowerCase();
        return this.searchSource.filter(item => [
          item.fullName, item.phoneNumber, item.email,
          item.address, item.tenantStatus, item.registeredBy, item.createdDate
        ].some(v => v && String(v).toLowerCase().includes(s)));
      },
      displayRows() {
        return this.filter ? this.filterTable.length : this.totalRows;
      },
    },
    mounted() {
      this.getModules();
      this.getAllTenantList();
      this.getOwnerUsers();
      this.getAllSystemUsers();
      this.$on("AfterComplete", () => {
        this.getAllTenantList();
      });
    },
    methods: {
      formatDate(dateString) {
        if (!dateString) return 'N/A';
        try {
          var date = new Date(dateString);
          return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
          });
        } catch (e) {
          return dateString;
        }
      },
      
      getStatusVariant(status) {
        if (!status) return 'secondary';
        if (status.indexOf('Rented') !== -1) {
          return 'success';
        } else if (status.indexOf('Free') !== -1) {
          return 'secondary';
        }
        return 'secondary';
      },
      
      numberWithCommas(x) {
        if(x !== null && x !== undefined && x !== ''){
          var num = parseFloat(x);
          if(!isNaN(num)){
            return num.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          }
          return x;
        }
        return '0.00';
      },
      
      buildPayload(page) {
        const payload = { page: page || this.currentPage, line: this.perPage };
        if (this.filters.userId) payload.userId = this.filters.userId;
        if (this.filters.registeredBy) payload.registeredBy = this.filters.registeredBy;
        if (this.filters.createdDate) payload.createdDate = this.filters.createdDate;
        if (this.filters.status !== null && this.filters.status !== undefined) payload.status = this.filters.status;
        if (this.filters.tenantStatus) payload.tenantStatus = this.filters.tenantStatus;
        return payload;
      },

      getOwnerUsers() {
        this.$store.dispatch('getAllOwnerUsers')
          .then(response => {
            Array.from(response.data).forEach(user => {
              this.ownerUserOptions.push({ value: user.id, text: user.fullName + ' (' + user.username + ')' });
            });
          })
          .catch(error => { console.log(error); });
      },

      getModules() {
        this.$store.dispatch('getModulesPermission', { userId: sessionStorage.getItem('userID') })
          .then(response => {
            var mod = response.data.modules.filter(x => x.name === 'TenantSuper');
            if (mod.length > 0) {
              this.modulePermission.view = mod[0].listData || 0;
              this.modulePermission.create = mod[0].createData || 0;
              this.modulePermission.update = mod[0].updateData || 0;
              this.modulePermission.delete = mod[0].deleteData || 0;
            }
          })
          .catch(error => { console.log(error); });
      },

      getAllSystemUsers() {
        this.$store.dispatch('getAllUsers')
          .then(response => {
            Array.from(response.data).forEach(user => {
              this.allUserOptions.push({ value: user.id, text: user.fullName || (user.firstName + ' ' + user.lastName) });
            });
          })
          .catch(error => { console.log(error); });
      },

      fetchAllForSearch() {
        if (!this.totalRows) return;
        const payload = this.buildPayload();
        payload.page = 1;
        payload.line = this.totalRows;
        this.$store.dispatch('getAllTenantList', payload)
          .then(response => { this.allItems = response.data.Contents || []; })
          .catch(error => { console.log('Error fetching all for search:', error); });
      },
      getAllTenantList() {
        this.spinner = true;
        this.allItems = [];
        this.$store.dispatch('getAllTenantList', this.buildPayload())
          .then(response => {
            this.items = response.data.Contents || [];
            this.totalRows = response.data.totalElements || 0;
            if (this.filter && this.filter.trim()) this.fetchAllForSearch();
          })
          .catch(error => { console.log('Error fetching tenants:', error); })
          .finally(() => { this.spinner = false; });
      },

      applyFilters() {
        this.currentPage = 1;
        this.getAllTenantList();
      },

      resetFilters() {
        this.filters.userId = null;
        this.filters.registeredBy = null;
        this.filters.createdDate = "";
        this.filters.status = null;
        this.filters.tenantStatus = null;
        this.filter = '';
        this.allItems = [];
        this.currentPage = 1;
        this.getAllTenantList();
      },

      changePage(event, page) {
        this.currentPage = page;
        this.spinner = true;
        this.$store.dispatch('getAllTenantList', this.buildPayload(page))
          .then(response => {
            this.items = response.data.Contents || [];
            this.totalRows = response.data.totalElements || 0;
          })
          .catch(error => { console.log('Error fetching tenants:', error); })
          .finally(() => { this.spinner = false; });
      },

      changePerPage() {
        this.currentPage = 1;
        this.spinner = true;
        this.$store.dispatch('getAllTenantList', this.buildPayload(1))
          .then(response => {
            this.items = response.data.Contents || [];
            this.totalRows = response.data.totalElements || 0;
          })
          .catch(error => { console.log('Error fetching tenants:', error); })
          .finally(() => { this.spinner = false; });
      },
      
      ViewDetail(ID){
        this.$store.dispatch('getDetailTenant', {tenantId: ID})
          .then(function(response){
            this.selectedTenant1 = response.data;
            this.$bvModal.show('modal-top-Details');
          }.bind(this))
          .catch(function(error){
            this.$notifications.notify({
              message: error.response ? error.response.data : 'Error loading tenant details',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'danger'
            });
            console.log(error);
          }.bind(this))
      },
      
      fetchAllAndExport(format) {
        if (!this.totalRows) {
          this.$notifications.notify({ message: 'No data to export.', horizontalAlign: 'center', verticalAlign: 'top', type: 'warning' });
          return;
        }
        const payload = this.buildPayload();
        payload.page = 1;
        payload.line = this.totalRows;
        this.$store.dispatch('getAllTenantList', payload)
          .then(response => {
            const all = response.data.Contents || [];
            if (!all.length) {
              this.$notifications.notify({ message: 'No data to export.', horizontalAlign: 'center', verticalAlign: 'top', type: 'warning' });
              return;
            }
            if (format === 'excel') this.doExportExcel(all);
            else this.doExportPDF(all);
          })
          .catch(error => { console.log('Export error:', error); });
      },

      exportExcel() { this.fetchAllAndExport('excel'); },
      exportPDF()   { this.fetchAllAndExport('pdf'); },

      doExportExcel(all) {
        const data = all.map((item, i) => ({
          'No.': i + 1,
          'Tenant Name': item.fullName,
          'Phonenumber': item.phoneNumber,
          'Email': item.email || 'N/A',
          'Address': item.address,
          'Status': item.tenantStatus,
          'Created At': item.createdDate,
          'Created By': item.registeredBy
        }));
        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Tenants');
        XLSX.writeFile(wb, 'Tenants.xlsx');
      },

      doExportPDF(all) {
        const doc = new jsPDF({ orientation: 'landscape' });
        doc.text('Tenants List', 14, 14);
        const rows = all.map((item, i) => [
          i + 1,
          item.fullName,
          item.phoneNumber,
          item.email || 'N/A',
          item.address,
          item.tenantStatus,
          item.createdDate,
          item.registeredBy
        ]);
        doc.autoTable({
          head: [['No.','Tenant Name','Phonenumber','Email','Address','Status','Created At','Created By']],
          body: rows,
          startY: 20
        });
        doc.save('Tenants.pdf');
      },

      clearData(){
        this.selectedTenant1 = {
          tenantId: null,
          ContractInformation: [],
          paymentInformation: [],
          familyInformation: [],
          TotalAmountForHouse: 0,
        };
        this.$emit('AfterComplete');
      }
    }
  }
</script>

<style lang="scss" scoped>
.table-container {
  overflow: auto;
}
.pagination-container {
  position: relative;
  z-index: 1;
  background: #fff;
}
.b-table-sticky-column:last-child {
  right: 0;
}
.text-warning {
  color: rgba(240, 206, 13, 0.937) !important;
}
.btn-icon {
  font-size: 24px;
  cursor: pointer;
  color: rgb(37, 91, 48);
}
.btn-icon:hover {
  color: rgba(240, 206, 13, 0.937);
}
.b-table-simple tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.075);
  cursor: pointer;
}
.close-icon {
  font-size: 24px;
  color: #6c757d;
  cursor: pointer;
}
.close-icon:hover {
  color: #dc3545;
}
</style>